"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReversePlasmaFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var ReversePlasmaFactory = /** @class */ (function (_super) {
    __extends(ReversePlasmaFactory, _super);
    function ReversePlasmaFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    ReversePlasmaFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    ReversePlasmaFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    ReversePlasmaFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    ReversePlasmaFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    ReversePlasmaFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return ReversePlasmaFactory;
}(contracts_1.ContractFactory));
exports.ReversePlasmaFactory = ReversePlasmaFactory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'uint256',
                name: 'blockNumber',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'proposalId',
                type: 'uint256',
            },
        ],
        name: 'NewBlockHeader',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'previousOwner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'OwnershipTransferred',
        type: 'event',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_ethBlockNumber',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_proposalId',
                type: 'uint256',
            },
        ],
        name: 'finalizeProposal',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_ethBlockNumber',
                type: 'uint256',
            },
            {
                internalType: 'bytes32',
                name: '_transactionsRoot',
                type: 'bytes32',
            },
            {
                internalType: 'bytes32',
                name: '_receiptsRoot',
                type: 'bytes32',
            },
        ],
        name: 'findProposal',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getAllValidators',
        outputs: [
            {
                internalType: 'address[]',
                name: '',
                type: 'address[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_ethBlockNumber',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_proposalId',
                type: 'uint256',
            },
        ],
        name: 'getEthHeaderProposal',
        outputs: [
            {
                components: [
                    {
                        internalType: 'bytes32',
                        name: 'transactionsRoot',
                        type: 'bytes32',
                    },
                    {
                        internalType: 'bytes32',
                        name: 'receiptsRoot',
                        type: 'bytes32',
                    },
                    {
                        internalType: 'address[]',
                        name: 'proposalValidators',
                        type: 'address[]',
                    },
                ],
                internalType: 'struct ReversePlasma.BlockHeaderProposal',
                name: '',
                type: 'tuple',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_ethBlockNumber',
                type: 'uint256',
            },
        ],
        name: 'getEthHeaderProposals',
        outputs: [
            {
                components: [
                    {
                        internalType: 'bytes32',
                        name: 'transactionsRoot',
                        type: 'bytes32',
                    },
                    {
                        internalType: 'bytes32',
                        name: 'receiptsRoot',
                        type: 'bytes32',
                    },
                    {
                        internalType: 'address[]',
                        name: 'proposalValidators',
                        type: 'address[]',
                    },
                ],
                internalType: 'struct ReversePlasma.BlockHeaderProposal[]',
                name: '',
                type: 'tuple[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_blockNumber',
                type: 'uint256',
            },
        ],
        name: 'getFinalizedEthHeader',
        outputs: [
            {
                components: [
                    {
                        internalType: 'bytes32',
                        name: 'transactionsRoot',
                        type: 'bytes32',
                    },
                    {
                        internalType: 'bytes32',
                        name: 'receiptsRoot',
                        type: 'bytes32',
                    },
                ],
                internalType: 'struct ReversePlasma.BlockHeaderFinalized',
                name: '',
                type: 'tuple',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_ethBlockNumber',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_proposalId',
                type: 'uint256',
            },
        ],
        name: 'getProposalValidators',
        outputs: [
            {
                internalType: 'address[]',
                name: '',
                type: 'address[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_ethBlockNumber',
                type: 'uint256',
            },
        ],
        name: 'getProposalsCount',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_validatorIndex',
                type: 'uint256',
            },
        ],
        name: 'getValidator',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_validator',
                type: 'address',
            },
        ],
        name: 'isValidator',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'latestBlockNumber',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_ethBlockNumber',
                type: 'uint256',
            },
            {
                internalType: 'bytes32',
                name: '_transactionsRoot',
                type: 'bytes32',
            },
            {
                internalType: 'bytes32',
                name: '_receiptsRoot',
                type: 'bytes32',
            },
        ],
        name: 'proposeBlock',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_startBlockNumber',
                type: 'uint256',
            },
            {
                internalType: 'address[]',
                name: '_validators',
                type: 'address[]',
            },
        ],
        name: 'setInitialValues',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address[]',
                name: '_validators',
                type: 'address[]',
            },
        ],
        name: 'setValidators',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
];
var _bytecode = '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';
//# sourceMappingURL=ReversePlasmaFactory.js.map